import { compact } from 'es-toolkit'

export const formatAddressLine = (
  street?: string,
  streetNumber?: string,
  postCode?: string,
  city?: string,
  countryName?: string
) => {
  const addressLine1 = compact([street || '', streetNumber || '']).join(' ')
  const addressLine2 = compact([postCode || '', city || '', countryName || '']).join(', ')

  return compact([addressLine1, addressLine2]).join(', ')
}
